<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close"  @click="$emit('close-appointment-modal')"><i class="las la-times"></i></button>
            <h4 class="modal-title">Aggiungi Date</h4>
        </template>
        <template v-slot:body>
            <div class="form-group" v-show="errorMessage">
                <div class="alert alert-danger" style="margin: 0 10px;">
                    {{errorMessage}}
                </div>
            </div>
            <MultipleAppointmentForm @change="onChangeNewAppointment" :new-appointment-prop="newAppointment" :appointment-count="appointmentCount"></MultipleAppointmentForm>
        </template>

        <template v-slot:footer>
            <a class="btn btn-primary btn-lg btn-block"
               href=""
               @click.prevent.stop="createNewAppointment()">
                <i class="las la-check"></i>
                {{ $t('components.appointment.add_dates') }}
            </a>
        </template>
    </ModalContainer>
</template>

<script>
    import MultipleAppointmentForm from "../appointment/MultipleAppointmentForm";
    import {createMultipleAppointment} from "../../api";
    import ModalContainer from "./ModalContainer";
    import i18n from "../../i18n"
    export default {
        name: "AddMultipleAppointmentModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            rateId: {
                type: Number,
                default: 0
            },
            appointmentCount: {
                type: Number,
                required: true
            }
        },
        data: () => {
            return {
                loading: false,
                newAppointment: {
                    date: [],
                    client_admin: null,
                    is_online: false,
                    notify: true,
                    location: null,

                },
                errorMessage: ""
            }
        },
        components: {ModalContainer, MultipleAppointmentForm},
        methods: {
            onChangeNewAppointment(newAppointment) {
                this.newAppointment = newAppointment;
            },
            async createNewAppointment() {
                this.errorMessage = "";

                this.loading = true;
                try {
                    await createMultipleAppointment(
                        this.rateId,
                        this.newAppointment.date,
                        this.newAppointment.client_admin,
                        this.newAppointment.is_online,
                        this.newAppointment.location);

                    this.$emit('success-create-appointment');
                    this.loading = false;
                    this.$route.params.successMessage = i18n.t('components.appointment.added_success')
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            }
        }
    };
</script>
